import React from "react";
import { Button } from "@speedoc/design-assets";
import { useMediaQuery } from "react-responsive";
import { trackCustom } from "../../services/analytics";
import Link from "./link";
import { GlobalStore } from "../../stores/global";
import { LazyLoadImage } from "react-lazy-load-image-component";

const HeroMain = ({ content }) => {
  const { config, currentCountryCode: countryCode } = GlobalStore.useState(c => c);
  const { appStoreLink, playStoreLink } = config.storeLinks;

  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });
  const handleButtonClick = code => {
    trackCustom("Contact", code);
  };

  return (
    <div id="heroMain">
      <div className="left">
        <div
          className="title"
          dangerouslySetInnerHTML={{ __html: isMobile && content.mobileTitle ? content.mobileTitle : content.title }}
        />
        <div className="description">{content.description}</div>
        {isMobile && <div className="right" style={{ backgroundImage: `url(${content.image.desktop.url})` }} />}

        <div className="cta">
          <Link
            link={content.link.path || ""}
            text={
              <Button onClick={e => handleButtonClick(countryCode)} className={`primary ${isMobile ? "sm" : ""}`}>
                <span>{content.link.text}</span>
              </Button>
            }
          />
        </div>

        <div className="buttons">
          <div className="button">
            <a href={appStoreLink} className="">
              <img src="//public.speedoc.com/strapi/btn_appleappstore_7d166925e8.svg" alt="" />
            </a>
          </div>
          <div className="button">
            <a href={playStoreLink} className="">
              <img src="//public.speedoc.com/strapi/btn_googleplay_ed1b5b2c10.svg" alt="" />
            </a>
          </div>
        </div>
      </div>
      {!isMobile && (
        <div className="right">
          <LazyLoadImage alt="hero" src={content.image?.desktop?.url} visibleByDefault={true} effect="blur" />
        </div>
      )}
    </div>
  );
};

export default HeroMain;
